import { formatPhoneNumber as libraryFormatPhoneNumber } from '@jjvgaming/player-payback-library'

export const formatPhoneNumber = (
  phone: number | string | undefined | null
): string => libraryFormatPhoneNumber(phone) ?? '-'

// Converts a phone number to a hex string
// Used for Referral Codes
export const convertPhoneNumberToHex = (phone: number): string =>
  phone?.toString(16).toUpperCase() ?? ''

// Converts a hex string to a phone number
// Used for Referral Codes
export const convertHexToPhoneNumber = (hex: string): number =>
  parseInt(hex, 16)
